import React from "react";
import HeadToHead from "../HeadToHead/HeadToHead";
import { FeaturedPlayerDetails } from "./types";
import "./index.scss";
import { omitNation } from "../../helpers";

interface FeaturedPlayerProps {
  featuredPlayer: FeaturedPlayerDetails;
}

export const FeaturedPlayer = (props: FeaturedPlayerProps) => {
  const {
    featuredPlayer: {
      givenName,
      familyName,
      playerNationalityCode,
      playerProfileLink,
      profileImage,
      itfRanking,
      rankMovement
    }
  } = props;

  let rankClass = "";
  if (rankMovement && rankMovement > 0) {
    rankClass = "positive";
  } else if (rankMovement && rankMovement < 0) {
    rankClass = "negative";
  }
  return (
    <div className="featured-player-rankings">
      <a href={playerProfileLink}>
        <div className="featured-player-rankings__img-container">
          {itfRanking ? (
            <span className="featured-player-rankings__main-ranking">
              {itfRanking}
            </span>
          ) : null}
          <img
            src={profileImage}
            alt={`${givenName} ${familyName} profile picture`}
          />
        </div>
      </a>
      <div className="featured-player-rankings__details-container">
        <div className="featured-player-rankings__player-details">
          <p>
            {givenName}
            <span>{familyName}</span>
          </p>
          <div className="itf-flag-container">
            <span className={`itf-flags itf-flags--${playerNationalityCode}`} />
            <span className="featured-player-rankings__nationality">
              {omitNation(playerNationalityCode)}
            </span>
          </div>
        </div>
        <div className="featured-player-rankings__ranking">
          <span className={rankClass}>
            {rankMovement > 0 ? "+" : ""}
            {rankMovement}
          </span>
          <a className="more-link" href={playerProfileLink}>
            View profile
          </a>
        </div>
      </div>
    </div>
  );
};

const FeaturedPlayerSection = (props: FeaturedPlayerProps) => {
  const { featuredPlayer } = props;
  const playerA = {
    familyName: featuredPlayer.familyName,
    givenName: featuredPlayer.givenName,
    playerNationalityCode: featuredPlayer.playerNationalityCode,
    playerId: featuredPlayer.playerId,
    profileImage: featuredPlayer.profileImage
  };

  const playerB = {
    familyName: "",
    givenName: "",
    playerNationalityCode: "",
    playerId: "",
    profileImage: ""
  };

  return (
    <div className="featured-player-section">
      <h2 className="featured-player-section__title">
        <span>Featured Player</span>
      </h2>
      <div className="featured-player-section__grid">
        <FeaturedPlayer {...props} />
        <div className="featured-player-details-container">
          <HeadToHead
            gender={featuredPlayer.gender}
            playerA={playerA}
            playerB={playerB}
            categoryCode={featuredPlayer.categoryCodes}
            allPlayersLink={featuredPlayer.allPlayersLink}
          />
        </div>
      </div>
    </div>
  );
};

export default FeaturedPlayerSection;
